// Action 提交的是 mutation，而不是直接变更状态。
// Action 可以包含任意异步操作。

/*eslint-disable*/


/* 导出actions方法 */
import { initNimSDK } from './initNimSDK'
import { initChatroomSDK, resetChatroomSDK } from './initChatroomSDK'
import ExampleApi from "@/api/ExampleApi";

function connectNim({ state, commit, dispatch }, obj) {
    // 操作为内容页刷新页面，此时无nim实例
    dispatch('initNimSDK', obj)
}

function connectChatroom({ state, commit, dispatch }, obj) {
    let { chatroomId } = Object.assign({}, obj)
    const nim = state.nim
    if (nim) {
        nim.getChatroomAddress({
            chatroomId,
            done: function getChatroomAddressDone(error, obj) {
                if (error) {
                    alert(error.message)
                    location.href = '#/'
                    return
                }
                dispatch('initChatroomSDK', obj)
            }
        })
    }
}

export default {
    // 连接sdk请求，false表示强制重连
    connect(store, obj) {
        let { type } = Object.assign({}, obj)
        // type 可为 nim chatroom
        type = type || 'nim'
        switch (type) {
            case 'nim':
                connectNim(store, obj)
                break
            case 'chatroom':
                connectChatroom(store, obj)
                break
        }
    },

    // 用户触发的登出逻辑
    logout({ state, commit }) {
        if (state.nim) {
            state.nim.disconnect()
        }
    },

    // 初始化 重新连接SDK
    initNimSDK,
    initChatroomSDK,
    // 更新回话列表
    async updateChatList({ store, commit }, sessions) {
        sessions.forEach(item => {
            switch (item.scene) {
                case "p2p":
                    let account = item.lastMsg.flow == "in" ? item.lastMsg.from : item.lastMsg.to
                    nim.getUser({
                        account: account,
                        done: function (error, user) {
                            if (!error) {
                                if (item.lastMsg.from == item.lastMsg.to) {
                                    item["nick"] = `我`;
                                } else {
                                    item["nick"] = user.nick;
                                }

                                item["avatar"] = user.avatar;
                                item["email"] = user.email;
                            }
                        }
                    });
                    break;
                case "team":
                    window.nim.getTeam({
                        teamId: item.to,
                        done: function (error, obj) {
                            if (!error) {
                                item["nick"] = obj.name;
                                item["avatar"] = obj.avatar;
                                item["email"] = obj.email;
                            }
                        }
                    });
                    break;
            }
        });
        // sessions.map(item=>{ })
        setTimeout(() => {
            commit("update_sessionList", sessions)
        }, 500)
    },
    async getTeamMembers({ commit, state }, item) {
        let list = Array.isArray(item) ? item : [item]
        let member = {}
        list.forEach(item => {
            let id = item.teamId
            window.nim.getTeamMembers({
                teamId: id,
                done: async (error, obj) => {
                    if (!error && obj) {
                        let owner = obj.members.filter(item => (item.type == 'owner'))
                        let ids = obj.members.filter(item => (item.account)).map(item => (item.account))
                        let res = await ExampleApi.getUserName({ accountList: ids, teamId: id })
                        if (res.data.code == 200) {
                            let sortList = []
                            res.data.data.forEach(item => {
                                if (item.imAccount == owner[0].account) {
                                    sortList.unshift(item)
                                } else {
                                    sortList.push(item)
                                }
                            })
                            let teamMenber = {}
                            teamMenber.teamId = '' + obj.teamId
                            teamMenber.menber = sortList
                            commit('SET_TEAMMENBER', teamMenber)
                        }
                    }
                }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js